import React, { useContext } from 'react'

import { useTranslation } from 'react-i18next'

import { TitleContext } from '@providers/TitleProvider'
import Tippy from '@tippyjs/react'
import { formatPriceInCents } from '@utils/formatters/number.formatter'

import EditScoreDetailsButton from './EditScoreDetailsButton'
import StopSellingButton from './StopSellingButton'

const SellerControls: React.FC = () => {
  const { title } = useContext(TitleContext)
  const { t } = useTranslation()

  const minPerformers = title.product?.minimum_initial_purchase_amount || 1

  let price = '$0.00'
  if (title.product?.price) {
    price = formatPriceInCents(title.product.price * minPerformers, {
      currency: title.product.currency,
      showDouble0ForCents: true,
    })
  }

  return (
    <>
      <p className="font-semibold text-md pb-1">{price}</p>
      <p>{t('content.cxPurchaseIncludes')}</p>
      <span className="font-semibold text-sm">
        {t('label.authorizedPerformers')}
        <Tippy arrow content={t('hint.authorizedPerformers')} placement="bottom" maxWidth={210}>
          <i className="nf-icon nf-help-sign ml-1 text-gray-icons align-text-bottom dark:text-gray-icons-dm" />
        </Tippy>
      </span>
      <EditScoreDetailsButton />
      <StopSellingButton />
    </>
  )
}

export default SellerControls
